import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

export default class extends Controller {
  connect() {
    this.initTwoItemsSwiper();
  }

  updateFocusableElements() {
    const swiper = this.twoItemsSwiper;
    if (!swiper) return;
    
    const slides = swiper.slides;
    
    slides.forEach(function(slide) {
      const focusableElements = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      focusableElements.forEach(function(element) {
        element.setAttribute('tabindex', '-1');
      });
    });
    
    const activeSlides = [];
    if (swiper.activeIndex !== undefined) {
      activeSlides.push(slides[swiper.activeIndex]);
      if (swiper.params.slidesPerView > 1 && swiper.activeIndex + 1 < slides.length) {
        activeSlides.push(slides[swiper.activeIndex + 1]);
      }
    }
    
    activeSlides.forEach(function(slide) {
        const focusableElements = slide.querySelectorAll('a, button, input, select, textarea, [tabindex="-1"]');
        focusableElements.forEach(function(element) {
          element.removeAttribute('tabindex');
        });
    });
  }

  initTwoItemsSwiper() {
    const element = this.element;
    const swiperElement = this.element.querySelector(".swiper");
    const slides = swiperElement.querySelectorAll('.swiper-slide');
    let virtualSlide;

    const equalizeCardHeights = () => {
      const maxHeight = Math.max(...Array.from(slides).map(slide => 
        slide.querySelector('.bg-white').offsetHeight
      ));
      slides.forEach(slide => {
        slide.querySelector('.bg-white').style.minHeight = `${maxHeight}px`;
      });
    };

    if (slides.length % 2 !== 0 && window.innerWidth >= 1127) {
      virtualSlide = slides[0].cloneNode(true);
      virtualSlide.style.visibility = 'hidden';
      virtualSlide.classList.add('virtual-slide');
      swiperElement.querySelector('.swiper-wrapper').appendChild(virtualSlide);
    }

    const nextBtn = this.element.querySelector('.next');
    const prevBtn = this.element.querySelector('.prev');
    const indicators = this.element.querySelector('.indicators');

    let resizeTimeout;
    window.addEventListener('resize', () => {
      const hasVirtual = swiperElement.querySelector('.virtual-slide');
      if (window.innerWidth >= 1127 && slides.length % 2 !== 0 && !hasVirtual) {
        virtualSlide = slides[0].cloneNode(true);
        virtualSlide.style.visibility = 'hidden';
        virtualSlide.classList.add('virtual-slide');
        swiperElement.querySelector('.swiper-wrapper').appendChild(virtualSlide);
      } else if (window.innerWidth < 1127 && hasVirtual) {
        hasVirtual.remove();
      }
      this.twoItemsSwiper.update();
      
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(equalizeCardHeights, 250);
    });

    this.twoItemsSwiper = new Swiper(swiperElement, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 50,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: indicators,
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className} indicator-dot"></span>`;
        }
      },
      breakpoints: {
        1127: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 10,
        }
      },
      on: {
        slideChange: function() {
          const activeIndex = this.realIndex / 2;
          const colors = ['#E7ECEE', '#E9DECA', '#E2D6E5', '#D4D8E4'];
          const parentDiv = element;
          parentDiv.style.backgroundColor = colors[activeIndex % colors.length];
          equalizeCardHeights();
        },
        init: function() {
          setTimeout(() => {
            equalizeCardHeights();
            this.emit('slideChange');
          }, 100);
        },
        imagesReady: function() {
          equalizeCardHeights();
        }
      },
    });

    this.updateFocusableElements();
    
    this.twoItemsSwiper.on('slideChange', () => this.updateFocusableElements());
    this.twoItemsSwiper.on('slidesLengthChange', () => this.updateFocusableElements());
    this.twoItemsSwiper.on('breakpoint', () => this.updateFocusableElements());
    this.twoItemsSwiper.on('update', () => this.updateFocusableElements());
  }
}
